import * as React from 'react';
import { withMemo } from 'PyzShopUi/scripts/react/common/hoc/withMemo';
import useLanguageSelect from 'PyzShopUi/scripts/product-review/hooks/useLanguageSelect';
import MdcSelect from 'PyzShopUi/scripts/shop-ui/components/select/MdcSelect';
import {ISelectOption} from 'PyzShopUi/scripts/shop-ui/interfaces';
import i18next from 'i18next';

interface IMdcLanguageSelectProps {
    itemLanguageOptions: ISelectOption[];
    currentItemsLanguage: string;
    dispatch: React.Dispatch<any>;
}

const MdcLanguageSelectComponent: React.FunctionComponent<IMdcLanguageSelectProps> = props => {
    const [languageOptions, onLanguageSelect] = useLanguageSelect(props.itemLanguageOptions, props.dispatch);
    const ariaLabel = i18next.t('Please select language', { ns: 'header' });
    return (
        <MdcSelect
            selectedValue={props.currentItemsLanguage}
            options={languageOptions}
            onChange={onLanguageSelect}
            ariaLabel={ariaLabel}
        />
    );
};

const MdcLanguageSelect = withMemo(MdcLanguageSelectComponent);

export default MdcLanguageSelect;
